module.exports = __webpack_public_path__ + "static/3_2_Bayes-Rule_1_SK-295319f4d2e35e804790168894b35294.svg";